import createActions from "helpers/actionCreator"

export const { Types, Creators } = createActions("ompnt/app/history", {
  identify: [],
  selectAccount: ["account"],
  selectPortfolio: ["portfolio"],
  navigate: ["location"],
})
